import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { WishlistExportState } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistExport/types';

const getState = (state: State): WishlistExportState => state.myAccount.wishlists.wishlistActions.export;

const getWishlistExportData = (state: State): RemoteRecord<Record<string, any>> => new RemoteRecord(getState(state));

export { getState, getWishlistExportData };
